import type { CompanyDisplayInfo } from '../types';

export interface CompanyRepository {
    getInfo(id: string, type: string): Promise<CompanyDisplayInfo>;
}

export const CompanyRepository = Symbol('CompanyRepository');
